import { FC } from 'react';
import { Box, Text } from '@chakra-ui/react';

export const DateHeader: FC<{ title: string }> = ({ title }) => (
  <Box data-testid="date-header">
    <Text color="gray.600" fontWeight="semibold" textTransform="uppercase">
      {title}
    </Text>
  </Box>
);
